<template>
  <v-data-table :headers="headers"
                :items="combinedActions"
                item-key="nr"
                class="mt-4"
                hide-default-footer
                :mobile-breakpoint="0"
                :items-per-page="-1"
                :class="{ 'elevation-1': $vuetify.breakpoint.smAndDown }">
    <template #item.action="{ item }">
      {{ $t('actionType.' + item.action) }}
    </template>
    <template #item.actionDate="{ item }">
      {{ item.actionDate | formatDate }}
    </template>
  </v-data-table>
</template>

<script>
  export default {
    props: ['debt'],
    computed: {
      headers () {
        return [
          { text: this.$t('action'), value: 'action' },
          { text: this.$t('date'), value: 'actionDate' },
        ]
      },
      combinedActions () {
        let actions = []
        
        // Add existing expiration actions
        if (this.debt.expirationActions) {
          actions = [...this.debt.expirationActions]
        }
        
        // Add notification attempts as actions
        if (this.debt.notificationAttempts && this.debt.notificationAttempts.length > 0) {
          const notificationActions = this.debt.notificationAttempts.map((attempt, index) => ({
            nr: `notification_${index}`,
            action: `10.${attempt.notificationChannel}`,
            actionDate: attempt.notificationDate
          }))
          
          actions = [...actions, ...notificationActions]
        }
        
        // Sort by actionDate (newest first)
        return actions.sort((a, b) => {
          const dateA = new Date(a.actionDate)
          const dateB = new Date(b.actionDate)
          return dateB - dateA
        })
      }
    }
  }
</script>
